import FacilitiesIAReview from '@/pages/cars/FacilitiesIAReview.vue'
import CARSFacilitiesQAList from '@/pages/cars/FacilitiesQAList.vue'

import store from '@/store'

const routes = [
    {
        path: 'initial-acceptance/facilities',
        name: 'CARSFacilitiesIAReview',
        component: FacilitiesIAReview,
        meta: {
            auth: true,
            gate: () => (
                [
                    "cars-review-nf", "cars-review-lidar", "cars-review-lidar-data",
                    "cars-review-photometer", "cars-review-photometer-data",
                    "cars-view-ia-submission", "cars-view-ia-report"
                ].some(p => store.getters['auth/permissions'].includes(p))
            )
        }
    },
    {
        path: 'quality-assurance/facilities',
        name: 'CARSFacilitiesQAList',
        component: CARSFacilitiesQAList,
        meta: {
            auth: true,
            gate: () => {
                return store.getters['auth/permissions'].includes('cars-view-lidar-evaluations')
            }
        }
    }
]

export default routes